module.exports = {"650109001":"石化街道","650109002":"地磅街道","650109003":"卡子湾街道","650109004":"古牧地东路街道","650109005":"古牧地西路街道","650109006":"南路街道","650109007":"永祥街街道","650109008":"盛达东路街道","650109100":"古牧地镇","650109101":"铁厂沟镇","650109102":"长山子镇","650109103":"羊毛工镇","650109104":"三道坝镇","650109200":"柏杨河乡","650109201":"芦草沟乡","650109500":"兵团梧桐镇分部"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650109.json
// module id = 3195
// module chunks = 0